export const getSelectedTrip = (currentVoyage, selectedTripId) => {
  const trips = currentVoyage?.trips || {};
  if (!selectedTripId) return null;
  if (trips[selectedTripId]) return trips[selectedTripId];

  // Backward compatibility for older sessions that may still store numeric indexes.
  const index = Number(selectedTripId);
  if (Number.isInteger(index) && index >= 0) {
    return Object.values(trips)[index] || null;
  }
  return null;
};

export const getVoyageTripsArray = (currentVoyage) =>
  Object.values(currentVoyage?.trips || {});

export const hasVoyageTrips = (currentVoyage) =>
  getVoyageTripsArray(currentVoyage).length > 0;

export const getSelectedCargo = (
  currentVoyage,
  selectedTripId,
  selectedCargoIndex
) => {
  const trip = getSelectedTrip(currentVoyage, selectedTripId);
  if (!trip) return null;
  return trip.cargos?.[selectedCargoIndex] || null;
};
